/**
 * Inverts keys and values, where keys are returned as values and values as keys. Be careful
 * to flip only objects where keys and values are any mixture of number or strings
 *
 * NOTE: Please notice that by making a flip, if keys were numbers will be converted to string because 'entries' will convert it
 * string value, if values are numbers will be placed/recovered as strings
 *
 * @example
 * // given
 * const x =  { 1: 'b'};
 * // when
 * const y = flip(x)
 * // then y = {'b': '1'}
 *
 * @param data
 * @returns
 */
export const flip = (data: { [key: string | number]: string | number }) =>
  Object.assign({}, ...Object.entries(data).map(([k, v]) => ({ [v]: k })));
